// src/pages/auth/PendingApproval.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { Clock } from "lucide-react";

export default function PendingApproval() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-50 via-cyan-50 to-white px-4">
      <div className="bg-white max-w-md w-full p-8 rounded-2xl shadow-xl border border-emerald-100 text-center">
        <div className="bg-emerald-100 text-emerald-700 inline-block p-4 rounded-full mb-4">
          <Clock size={40} />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Your account has been created successfully
        </h2>
        <p className="text-sm text-gray-700 mb-4 leading-6">
          Your business profile is under review. You will be notified via the
          provided email and number once it is approved.
        </p>
        <button
          onClick={() => navigate("/login")}
          className="mt-4 inline-flex items-center justify-center bg-emerald-600 text-white px-5 py-2 rounded-lg hover:bg-emerald-700 transition font-medium"
        >
          Back to Login
        </button>
      </div>
    </div>
  );
}
